import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SampleComponent } from './main/sample/sample.component';
import { AuthGuard } from './shared/guards/auth-guard';
import { CanDeactivateGuard } from './shared/guards/interface-allow-exit.guard';

const routes: Routes = [
    {
        path: 'auth',
        loadChildren: './main/autenticacion/autenticacion.module#AutenticacionModule'
    },
    {
        path: 'agentes',
        loadChildren: './main/agentes/agentes.module#AgentesModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'coberturas',
        loadChildren: './main/coberturas/coberturas.module#CoberturasModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'companias',
        loadChildren: './main/companias/companias.module#CompaniasModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'sucursales',
        loadChildren: './main/sucursales/sucursales.module#SucursalesModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'ramos',
        loadChildren: './main/ramos/ramos.module#RamosModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'clientes',
        loadChildren: './main/clientes/clientes.module#ClientesModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'grupos',
        loadChildren: './main/grupos/grupos.module#GruposModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'tipocambio',
        loadChildren: './main/tipocambio/tipocambio.module#TipoCambioModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'usuarios',
        loadChildren: './main/utilerias/utilerias.module#UtileriasModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'interfaces',
        loadChildren: './main/interfaces/interfaces.module#InterfacesModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'captura',
        loadChildren: './main/captura/captura.module#CapturaModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'consulta',
        loadChildren: './main/consulta/consulta.module#ConsultaModule',
        canActivate: [AuthGuard]
    }, 
    {
        path: 'reportes',
        loadChildren: './main/reportes/reportes.module#ReportesModule',
        canActivate: [AuthGuard]
    },
    {
        path: '**',
        component: SampleComponent,
        canActivate: [AuthGuard]
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
    providers: [AuthGuard, CanDeactivateGuard]
})
export class AppRoutingModule { }
